import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { AuthGuard } from '../common';
import { SystemAdminGuard } from '../common/guard/system-admin.guard';
import { ClientGuard } from '../common/guard/client.guard';
import { ClinicianGuard } from '../common/guard/clinician.guard';
import { AdminRoleGuard } from '../common/guard/admin-role.guard';
import { OrgAdminGuard } from '../common/guard/org-admin.guard';
import { ClinicAdminGuard } from '../common/guard/clinic-admin.guard';
import { ClinicianSocialworkerGuard } from '../common/guard/clinician-socialworker.guard';
import { OrgUserRoleGuard } from '../common/guard/org-user-role.guard';

export const homeRoutes: Routes = [
    {
        path: 'app',
        component: HomeComponent,
        children: [

            { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
            { path: '', loadChildren: '../dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
            { path: 'announcement', loadChildren: '../announcement/announcement.module#AnnouncementModule', canActivate: [AuthGuard] },
            { path: 'appointment', loadChildren: '../appointment/appointment.module#AppointmentModule', canActivate: [AuthGuard] },
            { path: 'clinics', loadChildren: '../clinic/clinic.module#ClinicModule', canActivate: [AuthGuard] },
            { path: 'user', loadChildren: '../user/user.module#UserModule', canActivate: [AuthGuard] },
            { path: 'availability', loadChildren: '../schedule/schedule.module#ScheduleModule', canActivate: [AuthGuard] },
            { path: 'room', loadChildren: '../room/room.module#RoomModule', canActivate: [AuthGuard] },
            { path: 'patient', loadChildren: '../patient/patient.module#PatientModule', canActivate: [AuthGuard, OrgUserRoleGuard] },
            { path: 'organization', loadChildren: '../organization/organization.module#OrganizationModule', canActivate: [AuthGuard] },
            {
                path: 'appointmenttype', loadChildren: '../org-appointment/org-appointment.module#OrgAppointmentModule',
                canActivate: [AuthGuard]
            },
            { path: 'resources', loadChildren: '../resources/resources.module#ResourcesModule', canActivate: [AuthGuard] },
            {
                path: 'resourcescategory', loadChildren: '../resource-category-list/resource-category-list.module#ResourceCategoryListModule',
                canActivate: [AuthGuard]
            },
            { path: 'food-shelters', loadChildren: '../food-shelters/food-shelters.module#FoodSheltersModule', canActivate: [AuthGuard] },
            {
                path: 'county-emergency-info',
                loadChildren: '../county-emergency-info/county-emergency-info.module#CountyEmergencyInfoModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'waitingroom', loadChildren: '../waiting-room/waiting-room.module#WaitingRoomModule',
                canActivate: [AuthGuard, ClinicianSocialworkerGuard]
            },
            { path: 'checkin', loadChildren: '../checkin/checkin.module#CheckinModule', canActivate: [AuthGuard, ClientGuard] },
            { path: 'report', loadChildren: '../report/report.module#ReportModule' },
            {
                path: 'emailConfig', loadChildren: '../email-config/email-config.module#EmailConfigModule',
                canActivate: [AuthGuard, SystemAdminGuard]
            },
            { path: 'family', loadChildren: '../family/family.module#FamilyModule', canActivate: [AuthGuard, OrgUserRoleGuard] },
            { path: 'mylibrary', loadChildren: '../my-library/my-library.module#MyLibraryModule', canActivate: [AuthGuard] },
            { path: 'clinichour', loadChildren: '../clinic-hours/clinic-hours.module#ClinicHoursModule', canActivate: [AuthGuard] },
            {
                path: 'covidtracking', loadChildren: '../covid-tracking/covid-tracking.module#CovidTrackingModule',
                canActivate: [AuthGuard]
            },
            { path: 'upload', loadChildren: '../bulk-data-upload/bulk-data-upload.module#BulkDataUploadModule', canActivate: [AuthGuard] },
            {
                path: 'moveresource', loadChildren: '../move-resource/move-resource.module#MoveResourceModule',
                canActivate: [AuthGuard, SystemAdminGuard]
            },
            { path: 'grade-6-8', loadChildren: '../middle-referral-form/middle-referral-form.module#MiddleReferralFormModule', canActivate: [AuthGuard] },
            { path: 'referral', loadChildren: '../referrals/referrals.module#ReferralsModule', canActivate: [AuthGuard] },
            { path: 'grade-PK-3', loadChildren: '../primary-elementary-referral-form/primary-elementary-referral-form.module#PrimaryElementaryReferralFormModule', canActivate: [AuthGuard] },
            { path: 'grade-4-5', loadChildren: '../intermediate-referral-form/intermediate-referral-form.module#IntermediateReferralFormModule', canActivate: [AuthGuard] },
            { path: 'grade-9-11', loadChildren: '../high1-referral-form/high1-referral-form.module#High1ReferralFormModule', canActivate: [AuthGuard] },
            { path: 'grade-10-12', loadChildren: '../high2-referral-form/high2-referral-form.module#High2ReferralFormModule', canActivate: [AuthGuard] },
            { path: 'tuffbag', loadChildren: '../tuff-bag/tuff-bag.module#TuffBagModule', canActivate: [AuthGuard] },
            {
                path: 'configuration', loadChildren: '../configuration/configuration.module#ConfigurationModule',
                canActivate: [AuthGuard]
            },

        ]

    }
];

